import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <div className="flex flex-col h-screen bg-[#F2F0FA] ">
      <div className="flex flex-1 overflow-y-hidden">
        <Sidebar />
        <main className="flex-1">
          <Navbar />
          <div className="overflow-y-auto overflow-x-hidden">
            <div className="flex flex-wrap p-6 h-screen w-[1205px] mx-auto">
              <div className="flex-1 pb-28">
                <Outlet />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
